<template>
  <div>
    <el-radio-group v-model="currentType" @change="searcHistory()" style="margin: 20px 0 0 0">
      <el-radio-button label="day">日度</el-radio-button>
      <el-radio-button label="week">周度</el-radio-button>
      <el-radio-button label="month">月度</el-radio-button>
    </el-radio-group>
    <ve-histogram class="data-area" :data="chartData" width="95%" :height="tableHeight"></ve-histogram>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return{
      baseApi: '/history',
      currentType: 'day',
      chartData: {
        columns: ['日期', '单词量'],
        rows: [
        ]
      },
      tableHeight: `${String(document.body.clientHeight/1.3)}px`
    }
  },
  computed: {
    ...mapGetters({
      info: 'getInfo',
    })
  },
  methods: {
    searcHistory() {
      this.$fly.post(`${this.baseApi}/${this.currentType}`,{'id': this.info.id}).then((res)=>{
        let li = [];
        for (let i = 0; i < res.length; i++) {
          const d = res[i];
          let item = {
            '日期': d.date,
            '单词量': d.dayWordCount,
          }
          li.push(item)
        }
        this.chartData.rows = li
      })
    }
  },
  created() {
    this.searcHistory()
  }
}
</script>

<style>
.data-area{
  margin: 22px 0 0 5%
}
</style>
